/*
 * @Author: chenxin
 * @Date: 2022-03-30 11:15:53
 * @LastEditTime: 2022-11-14 17:39:27
 * @Description: file content
 */
import store from "../store";
import axios from 'axios'
/**
 * @name 导入qiankun注册微应用方法
 */
import qianKunStart from "./app-register"
/**
 * @name 导入无需服务端获取的微应用
 */
import {appList as configAppList, noAuthApps} from "./app-config"

import { getStore, setStore } from '@/utils/storage'
/**
 * @name 验证用户身份并注册微应用
 */
const microAppStart = async() => {
  const formatsMsg =  await axios.get('/config/formats.json')
  const formatsData = process.env.VUE_APP_FORMATS? formatsMsg[process.env.VUE_APP_FORMATS] : formatsMsg['default']
  const token = getStore('privateAccessToken')
  const isDev = process.env.NODE_ENV === 'development'

  const url = new URL(window.location.href)
  let appId, industryId, appList, authAppList
  if(isDev) {
    appId = url.searchParams.get('appId')
    appList = configAppList
  } else {
    const info =  await axios.get('/config/app.json')
    appId = info.appId
    industryId = info.industryId
    appList = info.appList
    authAppList = info.authAppList
  }
  const defaultID = isDev ? formatsData.defaultID : appId
  let urlToken = url.searchParams.get('privateAccessToken')
  const pathNameItem = url.pathname.split('/')
  const linkCode = (pathNameItem[pathNameItem.length - 1] !== 'login' && pathNameItem[pathNameItem.length - 3] === 'auth') ? pathNameItem[pathNameItem.length - 1] : undefined

  const noAuthAppsCp = noAuthApps.filter((i) => {
    return i
  })
  store.dispatch('setAppID', defaultID)
  setStore('industryId', isDev ? formatsData.industryId : industryId)
  localStorage.setItem('type', formatsData.performanceReport)
  if(urlToken && appId) {
    store.dispatch('setAppID', appId)
    store.dispatch('setToken', urlToken)
    return linkCode ? qianKunStart(noAuthAppsCp) : qianKunStart(appList)
  }

  if (Number(getStore('oneProject')) === 1) {
    console.log("aaaaaa");
    setStore("oneProject", 0);
    if (token) {
       return
    }else {
      const href = window.location.href.replace("/project-choice", "");
      if (href) {
        location.href = href;
      } else {
        window.location.reload();
      }
    }
  }
  if(token && window.location.href && window.location.href.indexOf('/auth/project-choice') === -1 ) {
    store.dispatch('setToken', token)
    return qianKunStart(appList)
    // return linkCode ? qianKunStart(noAuthAppsCp) : qianKunStart(appList)
  }
  qianKunStart(noAuthAppsCp)
}

export default microAppStart
